import { Component } from '@angular/core'
import { DataService } from 'src/app/services/data-service'

@Component({
  selector: 'app-discente-modelo-relatorio-atividades',
  templateUrl: './discente-modelo-relatorio-atividades.component.html',
  styleUrls: ['./discente-modelo-relatorio-atividades.component.css'],
  standalone: false
})
export class DiscenteModeloRelatorioAtividadesComponent {
  constructor(
    private dataService: DataService
  ) {}

  download(): void {
    let downloadLink = document.createElement('a')
    if (this.dataService.getCurrentYear() >= 2025) {
      downloadLink.setAttribute('download', 'modelo-relatorio-atividades-2025.docx')
      downloadLink.href = 'assets/docs/modelo-relatorio-atividades-2025.docx'
    } else {
      downloadLink.setAttribute('download', 'modelo-relatorio-atividades.doc')
      downloadLink.href = 'assets/docs/modelo-relatorio-atividades.doc'
    }    
    document.body.appendChild(downloadLink)
    downloadLink.click()
    downloadLink.remove()
  }
}
